import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { zapierQueryKeys } from "./zapierQueryKeys";

export const useMutationZapierDisableIntegration = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => await api.zapierApi.disableIntegration(),
    onSuccess: async () =>
      await queryClient.invalidateQueries({ queryKey: zapierQueryKeys.all() }),
  });
};
